/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

(function() {

  function customizeCartItems() {
    

    document.querySelectorAll('.cart__item__content').forEach(content => {

      const title = content.querySelector('.cart__item__title');
      const meta = content.querySelector('.cart__item__meta');

      if (!title) return;

      const titleLink = title.querySelector('a') || title;


      /*
       * ==========================================
       * IDENTIFY CART ITEM TYPE
       * ==========================================
       */

      if (!titleLink.querySelector('.custom-cart-type')) {

        // ARMAÇÃO
        if (titleLink.textContent.includes('Armação')) {

          titleLink.innerHTML = titleLink.innerHTML.replace(
            'Armação |',
            '<span class="custom-cart-type">Armação</span>'
          );

          if (meta) {
            meta.classList.add('product-cart-item');
          }


        // ÓCULOS DE SOL
        } else if (titleLink.textContent.includes('Óculos de Sol')) {

          titleLink.innerHTML = titleLink.innerHTML.replace(
            'Óculos de Sol |',
            '<span class="custom-cart-type">Óculos de Sol</span>'
          );

          if (meta) {
            meta.classList.add('product-cart-item');
          }

          // CLIP ON
        } else if (titleLink.textContent.includes('Clip-On')) {

          titleLink.innerHTML = titleLink.innerHTML.replace(
            'Clip-On ','').replace(
            'Óculos |',
            '<span class="custom-cart-type">Óculos Clip-On</span>'
          );

          if (meta) {
            meta.classList.add('product-cart-item');
          }

        // LENTE
        } else if (titleLink.textContent.includes('Lente')) {

          titleLink.innerHTML = titleLink.innerHTML.replace(
            'Lente',
            '<span class="custom-cart-type">Lente</span>'
          );

          if (meta) {
            meta.classList.add('lens-cart-item');
          }

        }

      }


      /*
       * ==========================================
       * IDENTIFY LENSADVISOR PROPERTIES
       * Applies to ALL cart items
       * ==========================================
       */

      if (meta) {

        const properties = meta.querySelectorAll(
          '.cart__item__property, .cart__item__selected-options'
        );

        const lensAdvisorFields = [
          'prazo de produção:',
          'envio receita:',
          'envio da receita:',
          'tipo de receita:',
          'material lente:',
          'armação:',
          'lentes:'
        ];

        properties.forEach(property => {

          // Make comparison case-insensitive
          const text = property.textContent.toLowerCase();

          const isLensAdvisor = lensAdvisorFields.some(field =>
            text.includes(field)
          );

          if (isLensAdvisor) {
            property.classList.add('lensadvisor');
          }

        });

      }

    });

  }


  // Initial page load
  document.addEventListener('DOMContentLoaded', customizeCartItems);


  // Broadcast AJAX cart updates
  const observer = new MutationObserver(customizeCartItems);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
